import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2, SimpleChanges, Type } from '@angular/core';
import { NbDialogService, NbMenuItem } from '@nebular/theme';
import { MenuItemEditorDialogComponent } from '../menu-item-editor-dialog/menu-item-editor-dialog.component';

@Component({
  selector: 'kve-menu-item-navigator',
  templateUrl: './menu-item-navigator.component.html',
  styleUrls: ['./menu-item-navigator.component.scss']
})
export class MenuItemNavigatorComponent implements OnChanges{
  @Input() item:NbMenuItem;
  contentId:string;
  isSelected = false;
  shown = true;

  @Output() toggleSelect: EventEmitter<any> = new EventEmitter<any>();

  constructor(private dialogService: NbDialogService,
    private renderer2:Renderer2,
    private el:ElementRef<HTMLElement>){}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["item"]){
      console.log(this.item);
      this.contentId = this.item.data["contentId"]
    }
  }

  selectItem(contentId){
    this.isSelected = !this.isSelected;
    //this.toggleSelected();
    this.toggleSelect.emit({contentId:contentId,isSelected:this.isSelected});
  }
  editItem(contentId){
    console.log(contentId,this.item);
    let component:Type<any> = MenuItemEditorDialogComponent;
    //console.log(this.section);
    /* this.previewEditStoreService.selectedSite$.subscribe((site:Site) => {
      this.previewEditStoreService.selectedPageType$.subscribe((pageType:PageType) => {
        let page:Page = site.pages.find(page => page.pageType == pageType);
        if(page != undefined){
          page.sections.find(section)
        }
      });  
    }); */
    //this.previewEditStoreService.updateEditState(EditState.EDITING);
    let dialogRef = this.dialogService.open(component,{
      context: {
        item:this.item,
        //dialogWidth:960
        /* imgSrc:imgSrc,
        cellId:cellId,
        section:this.selectedSection,
        selectedCell:this.selectedCell,
        dialogWidth:960 */
      },
    })
    dialogRef.onClose.subscribe((resp:NbMenuItem) => {
      console.log(resp);
      //this.previewEditStoreService.updateSelectedSection(resp);
      //this.previewEditStoreService.updateEditState(EditState.UPDATED)
    })
  }
  editChildren(contentId){}

  deleteItem(contentId){}
  upItem(contentId){}
  downItem(contentId){}

  /* resolveSection(contentId:string){
    let renderedSection:RenderedSection;
    renderedSection = this.renderedSections.find(renderedSection => renderedSection.contentId == contentId);
    return renderedSection;
  } */
  
  toggleShow(contentId){
    this.shown = !this.shown;
    //console.log(this.shown);
    //let renderedSection = this.resolveSection(contentId);

  }

  toggleSelected(){
    this.isSelected = !this.isSelected;
    if(this.isSelected == true){
      //console.log("Is selected is true")
      //console.log(this.el.nativeElement)
      //First remove all active elements
      let parentEl = this.el.nativeElement.parentElement.parentElement;
      let activeEls =  parentEl.querySelectorAll('.isActive');
      if(activeEls != undefined){
        //console.log(activeEls)
        activeEls.forEach(el => {
          el.classList.toggle("isActive")
        })
      }     
      this.renderer2.addClass(this.el.nativeElement,"isActive");
      this.renderer2.addClass(this.el.nativeElement.parentElement,"isActive");
      this.renderer2.addClass(this.el.nativeElement.firstElementChild,"isActive")
    }
  }

}
